const colors = [
    'rgb(8,114,182)',
    "rgb(0,177,168)",
    "rgb(213,43,0)",
    "rgb(0,175,180)",
    "rgb(145,107,3)",
    "rgb(78,79,83)",
];

export default colors;